import request from '@/utils/request'
import Vue from 'vue';
export function getRoutes() {
  return request({
    url: `${Vue.prototype.$conf.visaService}/routes/getRoutes`,
    method: 'get'
  })
}

export function getRouteConfig(params) {
  return request({
    url: `${Vue.prototype.$conf.visaService}/routes/getRouteConfig/` + params,
    method: 'get'
  })
}

export function updateManagementUserRoutes(data) {
  return request({
    url: `${Vue.prototype.$conf.visaService}/managementUserRoutes/update`,
    method: 'post',
    data: data
  })
}